/**
 * Formula type enum
 */
export enum FormulaType {
  Capsule = 0,
  Powder = 1,
}

export const FORMULA_TYPE_MAP = {
  [FormulaType.Capsule]: "Capsule",
  [FormulaType.Powder]: "Powder",
};

/**
 * Ingredient/content item in a formula
 */
export interface FormulaContent {
  weight: number;
  name: string;
  activecomponent: string;
  idnumber: string;
  unit: string;
}

/**
 * Formula response from supplement provider API
 */
export interface FormulaResponse {
  bottleQTY: number;
  name: string;
  forid: number;
  price: number;
  basecost: number;
  notes: string;
  type: number;
  supply: number;
  filleridnumber: string;
  exactserving: string;
  numberofdoses: string;
  totalvolume: string;
  totalweight: string;
  totalservings: string;
  contents: FormulaContent[];
  flavors: string[] | null;
  locked: boolean;
  isOrderable: boolean;
  validateErrorMessage: string;
}

export interface CreateFormulaContentRequest {
  materialId: string;
  weight: number;
}

export interface CreateFormulaRequest {
  supply: number;
  contents: CreateFormulaContentRequest[];
  notes?: string;
  providerId?: string;
  patientId?: string;
}

export interface CreateFormulaResponse {
  /**
   * ID Number for the Formula in the DB
   */
  forid: number;

  /**
   * Name of the Formula (must be unique per user)
   */
  name: string;

  /**
   * Doses field is not used
   */
  dose: number | null;

  /**
   * Estimated Cost of Formula
   */
  price: number;

  /**
   * Notes saved with this formula
   */
  notes: string;

  /**
   * Dynamic properties for the formula
   */
  meta: string | null;

  /**
   * Type of Dose for Formula:
   * 0 = Capsule
   * 1 = Powder
   */
  type: FormulaType;

  /**
   * Number of daily servings supplied
   */
  supply: number;

  /**
   * Desired Filler for the formula, associated by idnumber
   */
  filleridnumber: string;

  /**
   * Not used at this time
   */
  exactserving: number | null;

  /**
   * Number of doses per day
   */
  numberofdoses: number;

  /**
   * Volume of the formula for a daily serving
   */
  totalvolume: number;

  /**
   * Weight of the formula for a daily serving
   */
  totalweight: number;

  /**
   * Weight of the formula for the whole supply amount
   */
  supplyweight: number;

  /**
   * Number of servings for the whole supply
   */
  totalservings: number;

  /**
   * Contents of the formula
   * Array of materials with their details
   */
  contents: FormulaContent[];
}
